import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import "./WelcomePage.css";
import AppFooter from "./AppFooter";
import { clearToken } from "./authStorage";

function WorkspacePrivacyPage() {
  const [contactOpen, setContactOpen] = useState(false);

  const handleLogout = () => {
    clearToken();
    window.location.replace("/login");
  };

  return (
    <div className="app-container welcome-page">
      <main className="welcome-workspace">
        <aside className="welcome-sidebar">
          <div className="welcome-sidebar-brand">
            <Link to="/welcome" className="welcome-sidebar-brand-link">
              <span className="welcome-sidebar-brand-mark" aria-hidden="true" />
              <span className="welcome-sidebar-brand-text">StatementIQ</span>
            </Link>
          </div>

          <div className="welcome-sidebar-nav">
            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Workspace</p>
              <Link to="/welcome" className="welcome-sidebar-link">
                Convert Statements
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Help &amp; Support</p>
              <Link to="/account" className="welcome-sidebar-link">
                Account
              </Link>
              <Link to="/workspace-faq" className="welcome-sidebar-link">
                FAQ
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Legal</p>
              <Link to="/privacy" className="welcome-sidebar-link active">
                Privacy Policy
              </Link>
              <Link to="/terms" className="welcome-sidebar-link">
                Terms of Service
              </Link>
            </div>
          </div>

          <div className="welcome-sidebar-support-card">
            <strong>Need help?</strong>
            <p>Our support team is here to assist you.</p>
            <button
              type="button"
              className="welcome-sidebar-support-button"
              onClick={() => setContactOpen(true)}
            >
              Contact Support
            </button>
          </div>
          <button
            type="button"
            className="welcome-sidebar-link welcome-sidebar-button welcome-sidebar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>
        </aside>

        <section className="welcome-content">
          <div className="welcome-body-grid">
            <div className="welcome-main-panel workspace-scroll-panel">
              <div className="welcome-heading-row">
                <div>
                  <h1>Privacy Policy</h1>
                  <p className="welcome-subtitle workspace-account-subtitle">
                    How StatementIQ processes, stores, and protects your uploaded bank statement data.
                  </p>
                </div>
              </div>

              <div className="workspace-legal-meta">
                <p>This service is operated by MinervaCredit, Inc.</p>
              </div>

              <div className="workspace-legal-content">
                <h2>1. Scope</h2>
                <p>
                  This Privacy Policy explains how StatementIQ collects, uses, stores, and deletes information when you use our
                  services. We process uploaded files solely to provide the conversion service requested by you.
                </p>

                <h2>2. Information We Process</h2>
                <h3>2.1 Uploaded Documents</h3>
                <p>
                  We process uploaded bank statement PDFs to extract and structure data into Excel output. Files are stored only
                  for processing, download access, and service delivery for up to 24 hours.
                </p>
                <h3>2.2 Optional Redacted Samples</h3>
                <p>
                  If a format is unsupported, you may voluntarily submit a redacted sample. Samples should not include personal
                  identifiers such as names, account numbers, addresses, or full bank details.
                </p>
                <h3>2.3 Optional Company Number Data</h3>
                <p>
                  If you provide a company number, we may retrieve publicly available company and director data to support
                  related-party checks.
                </p>
                <h3>2.4 Technical Metadata</h3>
                <p>
                  We may collect operational metadata such as timestamps, file size, and error logs required for security,
                  monitoring, and troubleshooting.
                </p>

                <h2>3. Purpose of Processing</h2>
                <ul>
                  <li>Process and convert uploaded statements.</li>
                  <li>Generate structured Excel output.</li>
                  <li>Support troubleshooting and service reliability.</li>
                  <li>Develop support for additional statement formats from redacted samples.</li>
                  <li>Run optional related-party checks using public company information.</li>
                </ul>

                <h2>4. Storage and Security</h2>
                <p>
                  Data is stored in secured cloud environments with appropriate access controls and safeguards. We do not access
                  unrelated files on your device. Only files you explicitly upload are processed.
                </p>

                <h2>5. Retention</h2>
                <p>
                  Uploaded statements, generated Excel files, and related job records are automatically deleted after 24 hours.
                  Redacted samples are retained only as long as needed for support and development.
                </p>

                <h2>6. Sharing</h2>
                <p>
                  We may use vetted service providers acting under confidentiality and security obligations. We do not sell or
                  rent personal data.
                </p>

                <h2>7. Contact</h2>
                <p>
                  For privacy-related queries, contact <a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {contactOpen && (
        <div className="welcome-tips-popup-overlay" onClick={() => setContactOpen(false)}>
          <div className="welcome-tips-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="welcome-tips-close"
              aria-label="Close contact popup"
              onClick={() => setContactOpen(false)}
            >
              ×
            </button>
            <div className="welcome-tips-header">
              <h2>Contact Us</h2>
            </div>
            <div className="welcome-contact-body">
              <p>If you need help with bank statement uploads, conversion issues, or account access, please contact our support team.</p>
              <p>Include your name, company, and a short summary of the issue so we can help quickly.</p>
              <p><a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a></p>
            </div>
          </div>
        </div>
      )}

      <AppFooter />
    </div>
  );
}

export default WorkspacePrivacyPage;
